import NoDataText from '@components/shelfDetails/NoDataText'
import ShelfContainer from '@components/shelfDetails/ShelfContainer'
import ShelfSkeleton from '@components/shelfDetails/ShelfSkeleton'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { useShelf } from '@state/shelf/queries'

interface EmptyShelfProps {
  shelfId: string
}

function EmptyShelf({ shelfId }: EmptyShelfProps) {
  const { t } = useTypedTranslation()
  const { data: shelf, isLoading } = useShelf(shelfId)

  if (isLoading || !shelf) return <ShelfSkeleton />

  const aspectRatio = shelf.width / shelf.height

  return (
    <ShelfContainer aspectRatio={aspectRatio}>
      <div className='absolute bottom-4/5 h-1/5 w-full'>
        <div className='absolute bottom-0 left-0 h-3 w-full bg-primary shadow-md' />
      </div>

      <div className='absolute bottom-3/5 h-1/5 w-full'>
        <div className='absolute bottom-0 left-0 h-3 w-full bg-primary shadow-md' />
      </div>

      <div className="absolute top-1/2 left-1/2 w-3/4 -translate-1/2 text-center text-sm font-bold text-secondary">
        {shelf.dayState === 'noData' ? <NoDataText lastObservedAt={shelf.lastObservedAt} /> : t('storeMap.shelf.noInformationAvailable')}
      </div>

      <div className='absolute bottom-2/5 h-1/5 w-full'>
        <div className='absolute bottom-0 left-0 h-3 w-full bg-primary shadow-md' />
      </div>

      <div className='absolute bottom-1/5 h-1/5 w-full'>
        <div className='absolute bottom-0 left-0 h-3 w-full bg-primary shadow-md' />
      </div>
    </ShelfContainer>
  )
}

export default EmptyShelf